import React, {useState,useEffect} from "react";

export default function SristiANI() {

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Set the height based on the screen width
  // Use a fixed height (e.g., 450px) for small screens (<= 768px)
  const bannerHeight = windowWidth <= 868 ? '450px' : '100vh';
  
  return (
    <div style={{overflow: "hidden" }}>
      {/* 🔹 Banner Section */}
     <section
      style={{
        backgroundImage: "url('/images/AboutOrgavitaz/About_Orgavitaz-Banner.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        // FIX: Dynamic height applied here
        height: bannerHeight, 
        width: "100vw",
        position: "relative",
        margin: "0",
        color: "#fff",
        overflow: "hidden",
        minHeight: "400px", // Maintains a minimum height even if 450px isn't reached (though redundant now)
      }}
    >
      {/* Banner Overlay (Covers the background image) */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      ></div>

      {/* Title at bottom of banner (Responsive Centering) */}
      <div
        style={{
          position: "absolute",
          bottom: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          backgroundColor: "rgba(0,0,0,0.5)",
          padding: "1rem 2rem",
          borderRadius: "10px",
          textAlign: "center",
          maxWidth: "90%",
          whiteSpace: "nowrap",
        }}
      >
        <h1 className="display-6 m-0">Sristi ANI & Orgavitaz</h1>
      </div>
    </section>

     <section className="container mb-5">
  {/* 🔹 Section 1 (Text Left, Image Right) */}
  <div className="row align-items-center">
    <div className="col-md-6 p-3">
      <h2>Sristi ANI and Orgavitaz</h2>
      <p style={{ textAlign: "justify" }}>
        Sristi ANI is the Active Natural Ingredients division of Sristi Bio-sciences
         Private Limited. Our core strengths in natural products R&D, particularly the actives library from plant,
          marine and animal sources has resulted in identifying a range of specialized actives from plant sources 
          that address basic deficiencies as dietary supplements. 
          Sristi ANI is an independent business division of Sristi Bio-sciences which integrates agriculture model,
           manufacturing model and the marketing offices across the various countries for a seamless integration of supply chain management for active natural ingredients.
      </p>
    </div>
    <div className="col-md-6 p-3">
      <img
        src="/images/AboutOrgavitaz/ANI.png"
        alt="Our Mission"
        className="img-fluid rounded"
        style={{ width: "100%", height: "350px", objectFit: "cover" }}
      />
    </div>
  </div>

  {/* 🔹 Section 2 (Image Left, Text Right) */}
  <div className="row align-items-center flex-row-reverse mt-5">
    <div className="col-md-6 p-3">
      <p style={{ textAlign: "justify" }}>
        Orgavitaz is the first family brand under Sristi ANI
         that is positioned to address a critical category of VDS
          (Vitamins and Dietary Supplements). VDS is dominated by either 
          synthetic with very high potency and poor bio-availability or
           isolates from natural sources that work very similar to synthetics.
            Orgavitaz addresses critical problems of VDS category by introducing 
            a new segment of Bio-vitamins that are functionally different from the existing vitamin supplements.
      </p>
    </div>
    <div className="col-md-6 p-3">
      <img
        src="/images/AboutOrgavitaz/ANI-1.png"
        alt="Global Integration"
        className="img-fluid rounded"
        style={{ width: "100%", height: "350px", objectFit: "cover" }}
      />
    </div>
  </div>

  {/* 🔹 Section 3 (Text Left, Image Right) */}
  <div className="row align-items-center mt-5">
    <div className="col-md-6 p-3">
      <p style={{ textAlign: "justify" }}>
        Orgavitaz is fully agriculture dependent standardization
         of vitamins and minerals that offer low concentration and
          highly bio-available format, which is completely opposite
           to the current trend of vitamins supplementation.
      </p>
      <p style={{ textAlign: "justify" }}>
       Orgavitaz is a Bio-potent, 100% natural, Vegan and certified
        Organic Vitamins and Minerals as whole-food complex derived
         from captively grown Indian Greens, vegetables and fruits. 
         Orgavitaz offers a balance of optimal dosage of Vitamins & Minerals
          for an average 2,000 calories-a-day diet. Recommended Dietary Allowance (RDA),
           Adequate Intake (AI) and Tolerable Upper Intake Level (UL) are optimized to make
            Orgavitaz the best DV contributor for optimal health. Orgavitaz brings variations 
            to accommodate age, physiological changes and metabolic conditions with choice for specific deficiencies,
             Children, Men, Women, Pregnant, Lactating, Diabetic, Sports, etc. Orgavitaz offer equivalents of certain
              less available vitamins through vegan sources like B12, D3 and K2.
      </p>
      <p style={{ textAlign: "justify" }}>
        Orgavitaz is available as bulk to manufacturers and marketers that comes with all documentation
         for establishing right packaging and label claims. Orgavitaz is available in formulation friendly 
         formats for formulators and manufacturers with good dispersibility, wettability, bulk density, hydration,
          emulsifying properties and gelation. We offer custom manufacturing and development for unique formulatory 
          specifications like pre mixes, soup mix, salad toppings, cookies, shakes, bakings, etc.
      </p>
    </div>
    <div className="col-md-6 p-3">
      <img
        src="/images/AboutOrgavitaz/Sristi_ANI.jpg"
        alt="Research & Development"
        className="img-fluid rounded"
        style={{ width: "100%", height: "350px", objectFit: "cover" }}
      />
    </div>
  </div>
</section>

    <section className="container my-5">
  {/* 🔹 Section 1 (Text Left, Image Right) */}
  <div className="row align-items-center mb-5">
    <div className="col-md-6 p-3">
      <h2>Orgavitaz as a Natural concentrate of Vitamins and Minerals
         as a complex derived from safe vegan sources helps to;</h2>
      <ul>
        <li>Enhance Immune Function</li>
        <li>Improve Cellular Metabolism and Cellular Interaction</li>
        <li>Promote Tissue Growth and Repair</li>
        <li>Helps regulate Gene and Enzyme Functions</li>
        <li>Lower Risk of Diabetes, Cancer, Heart Attack and Arthritis</li>
      </ul>
    </div>
    <div className="col-md-6 p-3">
      <img
        src="/images/AboutOrgavitaz/learn-vitamins.jpg"
        alt="Our Core Strengths"
        className="img-fluid rounded"
        style={{ width: "100%", height: "350px", objectFit: "cover" }}
      />
    </div>
  </div>

  </section> 
    </div>
  );
}
